import GlobalErrorHandler from './GlobalErrorHandler'

export default GlobalErrorHandler
